module.exports = __webpack_public_path__ + "fonts/FuturaStd-Bold.21e11f3e.woff";